"use client";
import * as A from "react";
import { useLayoutEffect as zt } from "react";
import { e as U, g as q, a as ie, b as N, m as se, c as I, d as gt, h as me, s as It, i as ht, j as pt, k as _t, l as jt, n as Nt, o as Yt, p as Oe, q as xt, t as Y, f as ue, r as ge } from "./floating-ui.utils-CqK2Pznf.mjs";
import { o as qt } from "./owner-DpSCkBia.mjs";
import { u as Ce } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as Re } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as Ut } from "./useEventCallback-CjuAhyNz.mjs";
import { u as Xt } from "./DirectionContext-D4ZBZehF.mjs";
import { f as Se, a as z, l as K, k as J, m as ot, g as X, c as G, h as wt, n as Pe, e as re, d as he, o as Kt, p as yt, q as Gt, j as De, r as Ee, s as xe } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import * as Jt from "react-dom";
import { u as Qt } from "./FloatingTree-vWe5pGqE.mjs";
import { u as Zt } from "./useFloatingRootContext-BSTWPoxk.mjs";
function st(e, t, i) {
  let {
    reference: n,
    floating: o
  } = e;
  const s = N(t), r = ht(t), c = pt(r), a = q(t), u = s === "y", f = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, g = n[c] / 2 - o[c] / 2;
  let l;
  switch (a) {
    case "top":
      l = {
        x: f,
        y: n.y - o.height
      };
      break;
    case "bottom":
      l = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      l = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      l = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      l = {
        x: n.x,
        y: n.y
      };
  }
  switch (ie(t)) {
    case "start":
      l[r] -= g * (i && u ? -1 : 1);
      break;
    case "end":
      l[r] += g * (i && u ? -1 : 1);
      break;
  }
  return l;
}
const en = async (e, t, i) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: r
  } = i, c = s.filter(Boolean), a = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let u = await r.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: d
  } = st(u, n, a), g = n, l = {}, m = 0;
  for (let p = 0; p < c.length; p++) {
    const {
      name: x,
      fn: w
    } = c[p], {
      x: v,
      y: h,
      data: y,
      reset: R
    } = await w({
      x: f,
      y: d,
      initialPlacement: n,
      placement: g,
      strategy: o,
      middlewareData: l,
      rects: u,
      platform: r,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = v ?? f, d = h ?? d, l = {
      ...l,
      [x]: {
        ...l[x],
        ...y
      }
    }, R && m <= 50 && (m++, typeof R == "object" && (R.placement && (g = R.placement), R.rects && (u = R.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : R.rects), {
      x: f,
      y: d
    } = st(u, g, a)), p = -1);
  }
  return {
    x: f,
    y: d,
    placement: g,
    strategy: o,
    middlewareData: l
  };
};
async function ce(e, t) {
  var i;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: s,
    rects: r,
    elements: c,
    strategy: a
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: g = !1,
    padding: l = 0
  } = U(t, e), m = gt(l), x = c[g ? d === "floating" ? "reference" : "floating" : d], w = me(await s.getClippingRect({
    element: (i = await (s.isElement == null ? void 0 : s.isElement(x))) == null || i ? x : x.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: a
  })), v = d === "floating" ? {
    x: n,
    y: o,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, h = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating)), y = await (s.isElement == null ? void 0 : s.isElement(h)) ? await (s.getScale == null ? void 0 : s.getScale(h)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = me(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: v,
    offsetParent: h,
    strategy: a
  }) : v);
  return {
    top: (w.top - R.top + m.top) / y.y,
    bottom: (R.bottom - w.bottom + m.bottom) / y.y,
    left: (w.left - R.left + m.left) / y.x,
    right: (R.right - w.right + m.right) / y.x
  };
}
const tn = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var i, n;
      const {
        placement: o,
        middlewareData: s,
        rects: r,
        initialPlacement: c,
        platform: a,
        elements: u
      } = t, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: g,
        fallbackStrategy: l = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...x
      } = U(e, t);
      if ((i = s.arrow) != null && i.alignmentOffset)
        return {};
      const w = q(o), v = N(c), h = q(c) === c, y = await (a.isRTL == null ? void 0 : a.isRTL(u.floating)), R = g || (h || !p ? [_t(c)] : jt(c)), C = m !== "none";
      !g && C && R.push(...Nt(c, p, m, y));
      const S = [c, ...R], P = await ce(t, x), H = [];
      let $ = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (f && H.push(P[w]), d) {
        const L = Yt(o, r, y);
        H.push(P[L[0]], P[L[1]]);
      }
      if ($ = [...$, {
        placement: o,
        overflows: H
      }], !H.every((L) => L <= 0)) {
        var M, V;
        const L = (((M = s.flip) == null ? void 0 : M.index) || 0) + 1, D = S[L];
        if (D && (!(d === "alignment" ? v !== N(D) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        $.every((b) => N(b.placement) === v ? b.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: $
            },
            reset: {
              placement: D
            }
          };
        let E = (V = $.filter((k) => k.overflows[0] <= 0).sort((k, b) => k.overflows[1] - b.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!E)
          switch (l) {
            case "bestFit": {
              var T;
              const k = (T = $.filter((b) => {
                if (C) {
                  const F = N(b.placement);
                  return F === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((b) => [b.placement, b.overflows.filter((F) => F > 0).reduce((F, W) => F + W, 0)]).sort((b, F) => b[1] - F[1])[0]) == null ? void 0 : T[0];
              k && (E = k);
              break;
            }
            case "initialPlacement":
              E = c;
              break;
          }
        if (o !== E)
          return {
            reset: {
              placement: E
            }
          };
      }
      return {};
    }
  };
};
function rt(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ct(e) {
  return It.some((t) => e[t] >= 0);
}
const nn = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: i
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = U(e, t);
      switch (n) {
        case "referenceHidden": {
          const s = await ce(t, {
            ...o,
            elementContext: "reference"
          }), r = rt(s, i.reference);
          return {
            data: {
              referenceHiddenOffsets: r,
              referenceHidden: ct(r)
            }
          };
        }
        case "escaped": {
          const s = await ce(t, {
            ...o,
            altBoundary: !0
          }), r = rt(s, i.floating);
          return {
            data: {
              escapedOffsets: r,
              escaped: ct(r)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, vt = /* @__PURE__ */ new Set(["left", "top"]);
async function on(e, t) {
  const {
    placement: i,
    platform: n,
    elements: o
  } = e, s = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), r = q(i), c = ie(i), a = N(i) === "y", u = vt.has(r) ? -1 : 1, f = s && a ? -1 : 1, d = U(t, e);
  let {
    mainAxis: g,
    crossAxis: l,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof m == "number" && (l = c === "end" ? m * -1 : m), a ? {
    x: l * f,
    y: g * u
  } : {
    x: g * u,
    y: l * f
  };
}
const sn = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var i, n;
      const {
        x: o,
        y: s,
        placement: r,
        middlewareData: c
      } = t, a = await on(t, e);
      return r === ((i = c.offset) == null ? void 0 : i.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
        x: o + a.x,
        y: s + a.y,
        data: {
          ...a,
          placement: r
        }
      };
    }
  };
}, rn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: i,
        y: n,
        placement: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: r = !1,
        limiter: c = {
          fn: (x) => {
            let {
              x: w,
              y: v
            } = x;
            return {
              x: w,
              y: v
            };
          }
        },
        ...a
      } = U(e, t), u = {
        x: i,
        y: n
      }, f = await ce(t, a), d = N(q(o)), g = xt(d);
      let l = u[g], m = u[d];
      if (s) {
        const x = g === "y" ? "top" : "left", w = g === "y" ? "bottom" : "right", v = l + f[x], h = l - f[w];
        l = Oe(v, l, h);
      }
      if (r) {
        const x = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", v = m + f[x], h = m - f[w];
        m = Oe(v, m, h);
      }
      const p = c.fn({
        ...t,
        [g]: l,
        [d]: m
      });
      return {
        ...p,
        data: {
          x: p.x - i,
          y: p.y - n,
          enabled: {
            [g]: s,
            [d]: r
          }
        }
      };
    }
  };
}, cn = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: i,
        y: n,
        placement: o,
        rects: s,
        middlewareData: r
      } = t, {
        offset: c = 0,
        mainAxis: a = !0,
        crossAxis: u = !0
      } = U(e, t), f = {
        x: i,
        y: n
      }, d = N(o), g = xt(d);
      let l = f[g], m = f[d];
      const p = U(c, t), x = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (a) {
        const h = g === "y" ? "height" : "width", y = s.reference[g] - s.floating[h] + x.mainAxis, R = s.reference[g] + s.reference[h] - x.mainAxis;
        l < y ? l = y : l > R && (l = R);
      }
      if (u) {
        var w, v;
        const h = g === "y" ? "width" : "height", y = vt.has(q(o)), R = s.reference[d] - s.floating[h] + (y && ((w = r.offset) == null ? void 0 : w[d]) || 0) + (y ? 0 : x.crossAxis), C = s.reference[d] + s.reference[h] + (y ? 0 : ((v = r.offset) == null ? void 0 : v[d]) || 0) - (y ? x.crossAxis : 0);
        m < R ? m = R : m > C && (m = C);
      }
      return {
        [g]: l,
        [d]: m
      };
    }
  };
}, ln = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var i, n;
      const {
        placement: o,
        rects: s,
        platform: r,
        elements: c
      } = t, {
        apply: a = () => {
        },
        ...u
      } = U(e, t), f = await ce(t, u), d = q(o), g = ie(o), l = N(o) === "y", {
        width: m,
        height: p
      } = s.floating;
      let x, w;
      d === "top" || d === "bottom" ? (x = d, w = g === (await (r.isRTL == null ? void 0 : r.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (w = d, x = g === "end" ? "top" : "bottom");
      const v = p - f.top - f.bottom, h = m - f.left - f.right, y = se(p - f[x], v), R = se(m - f[w], h), C = !t.middlewareData.shift;
      let S = y, P = R;
      if ((i = t.middlewareData.shift) != null && i.enabled.x && (P = h), (n = t.middlewareData.shift) != null && n.enabled.y && (S = v), C && !g) {
        const $ = I(f.left, 0), M = I(f.right, 0), V = I(f.top, 0), T = I(f.bottom, 0);
        l ? P = m - 2 * ($ !== 0 || M !== 0 ? $ + M : I(f.left, f.right)) : S = p - 2 * (V !== 0 || T !== 0 ? V + T : I(f.top, f.bottom));
      }
      await a({
        ...t,
        availableWidth: P,
        availableHeight: S
      });
      const H = await r.getDimensions(c.floating);
      return m !== H.width || p !== H.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Rt(e) {
  const t = X(e);
  let i = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = G(e), s = o ? e.offsetWidth : i, r = o ? e.offsetHeight : n, c = ge(i) !== s || ge(n) !== r;
  return c && (i = s, n = r), {
    width: i,
    height: n,
    $: c
  };
}
function Me(e) {
  return z(e) ? e : e.contextElement;
}
function ne(e) {
  const t = Me(e);
  if (!G(t))
    return Y(1);
  const i = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: s
  } = Rt(t);
  let r = (s ? ge(i.width) : i.width) / n, c = (s ? ge(i.height) : i.height) / o;
  return (!r || !Number.isFinite(r)) && (r = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: r,
    y: c
  };
}
const fn = /* @__PURE__ */ Y(0);
function At(e) {
  const t = J(e);
  return !wt() || !t.visualViewport ? fn : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function an(e, t, i) {
  return t === void 0 && (t = !1), !i || t && i !== J(e) ? !1 : t;
}
function Q(e, t, i, n) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  const o = e.getBoundingClientRect(), s = Me(e);
  let r = Y(1);
  t && (n ? z(n) && (r = ne(n)) : r = ne(e));
  const c = an(s, i, n) ? At(s) : Y(0);
  let a = (o.left + c.x) / r.x, u = (o.top + c.y) / r.y, f = o.width / r.x, d = o.height / r.y;
  if (s) {
    const g = J(s), l = n && z(n) ? J(n) : n;
    let m = g, p = ot(m);
    for (; p && n && l !== m; ) {
      const x = ne(p), w = p.getBoundingClientRect(), v = X(p), h = w.left + (p.clientLeft + parseFloat(v.paddingLeft)) * x.x, y = w.top + (p.clientTop + parseFloat(v.paddingTop)) * x.y;
      a *= x.x, u *= x.y, f *= x.x, d *= x.y, a += h, u += y, m = J(p), p = ot(m);
    }
  }
  return me({
    width: f,
    height: d,
    x: a,
    y: u
  });
}
function Le(e, t) {
  const i = xe(e).scrollLeft;
  return t ? t.left + i : Q(K(e)).left + i;
}
function bt(e, t, i) {
  i === void 0 && (i = !1);
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - (i ? 0 : (
    // RTL <body> scrollbar.
    Le(e, n)
  )), s = n.top + t.scrollTop;
  return {
    x: o,
    y: s
  };
}
function un(e) {
  let {
    elements: t,
    rect: i,
    offsetParent: n,
    strategy: o
  } = e;
  const s = o === "fixed", r = K(n), c = t ? Pe(t.floating) : !1;
  if (n === r || c && s)
    return i;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Y(1);
  const f = Y(0), d = G(n);
  if ((d || !d && !s) && ((De(n) !== "body" || Ee(r)) && (a = xe(n)), G(n))) {
    const l = Q(n);
    u = ne(n), f.x = l.x + n.clientLeft, f.y = l.y + n.clientTop;
  }
  const g = r && !d && !s ? bt(r, a, !0) : Y(0);
  return {
    width: i.width * u.x,
    height: i.height * u.y,
    x: i.x * u.x - a.scrollLeft * u.x + f.x + g.x,
    y: i.y * u.y - a.scrollTop * u.y + f.y + g.y
  };
}
function dn(e) {
  return Array.from(e.getClientRects());
}
function mn(e) {
  const t = K(e), i = xe(e), n = e.ownerDocument.body, o = I(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), s = I(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let r = -i.scrollLeft + Le(e);
  const c = -i.scrollTop;
  return X(n).direction === "rtl" && (r += I(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: s,
    x: r,
    y: c
  };
}
function gn(e, t) {
  const i = J(e), n = K(e), o = i.visualViewport;
  let s = n.clientWidth, r = n.clientHeight, c = 0, a = 0;
  if (o) {
    s = o.width, r = o.height;
    const u = wt();
    (!u || u && t === "fixed") && (c = o.offsetLeft, a = o.offsetTop);
  }
  return {
    width: s,
    height: r,
    x: c,
    y: a
  };
}
const hn = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function pn(e, t) {
  const i = Q(e, !0, t === "fixed"), n = i.top + e.clientTop, o = i.left + e.clientLeft, s = G(e) ? ne(e) : Y(1), r = e.clientWidth * s.x, c = e.clientHeight * s.y, a = o * s.x, u = n * s.y;
  return {
    width: r,
    height: c,
    x: a,
    y: u
  };
}
function lt(e, t, i) {
  let n;
  if (t === "viewport")
    n = gn(e, i);
  else if (t === "document")
    n = mn(K(e));
  else if (z(t))
    n = pn(t, i);
  else {
    const o = At(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return me(n);
}
function Ot(e, t) {
  const i = re(e);
  return i === t || !z(i) || he(i) ? !1 : X(i).position === "fixed" || Ot(i, t);
}
function xn(e, t) {
  const i = t.get(e);
  if (i)
    return i;
  let n = Se(e, [], !1).filter((c) => z(c) && De(c) !== "body"), o = null;
  const s = X(e).position === "fixed";
  let r = s ? re(e) : e;
  for (; z(r) && !he(r); ) {
    const c = X(r), a = yt(r);
    !a && c.position === "fixed" && (o = null), (s ? !a && !o : !a && c.position === "static" && !!o && hn.has(o.position) || Ee(r) && !a && Ot(e, r)) ? n = n.filter((f) => f !== r) : o = c, r = re(r);
  }
  return t.set(e, n), n;
}
function wn(e) {
  let {
    element: t,
    boundary: i,
    rootBoundary: n,
    strategy: o
  } = e;
  const r = [...i === "clippingAncestors" ? Pe(t) ? [] : xn(t, this._c) : [].concat(i), n], c = r[0], a = r.reduce((u, f) => {
    const d = lt(t, f, o);
    return u.top = I(d.top, u.top), u.right = se(d.right, u.right), u.bottom = se(d.bottom, u.bottom), u.left = I(d.left, u.left), u;
  }, lt(t, c, o));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function yn(e) {
  const {
    width: t,
    height: i
  } = Rt(e);
  return {
    width: t,
    height: i
  };
}
function vn(e, t, i) {
  const n = G(t), o = K(t), s = i === "fixed", r = Q(e, !0, s, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = Y(0);
  function u() {
    a.x = Le(o);
  }
  if (n || !n && !s)
    if ((De(t) !== "body" || Ee(o)) && (c = xe(t)), n) {
      const l = Q(t, !0, s, t);
      a.x = l.x + t.clientLeft, a.y = l.y + t.clientTop;
    } else o && u();
  s && !n && o && u();
  const f = o && !n && !s ? bt(o, c) : Y(0), d = r.left + c.scrollLeft - a.x - f.x, g = r.top + c.scrollTop - a.y - f.y;
  return {
    x: d,
    y: g,
    width: r.width,
    height: r.height
  };
}
function Ae(e) {
  return X(e).position === "static";
}
function ft(e, t) {
  if (!G(e) || X(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let i = e.offsetParent;
  return K(e) === i && (i = i.ownerDocument.body), i;
}
function Ct(e, t) {
  const i = J(e);
  if (Pe(e))
    return i;
  if (!G(e)) {
    let o = re(e);
    for (; o && !he(o); ) {
      if (z(o) && !Ae(o))
        return o;
      o = re(o);
    }
    return i;
  }
  let n = ft(e, t);
  for (; n && Kt(n) && Ae(n); )
    n = ft(n, t);
  return n && he(n) && Ae(n) && !yt(n) ? i : n || Gt(e) || i;
}
const Rn = async function(e) {
  const t = this.getOffsetParent || Ct, i = this.getDimensions, n = await i(e.floating);
  return {
    reference: vn(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function An(e) {
  return X(e).direction === "rtl";
}
const bn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: un,
  getDocumentElement: K,
  getClippingRect: wn,
  getOffsetParent: Ct,
  getElementRects: Rn,
  getClientRects: dn,
  getDimensions: yn,
  getScale: ne,
  isElement: z,
  isRTL: An
};
function St(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function On(e, t) {
  let i = null, n;
  const o = K(e);
  function s() {
    var c;
    clearTimeout(n), (c = i) == null || c.disconnect(), i = null;
  }
  function r(c, a) {
    c === void 0 && (c = !1), a === void 0 && (a = 1), s();
    const u = e.getBoundingClientRect(), {
      left: f,
      top: d,
      width: g,
      height: l
    } = u;
    if (c || t(), !g || !l)
      return;
    const m = ue(d), p = ue(o.clientWidth - (f + g)), x = ue(o.clientHeight - (d + l)), w = ue(f), h = {
      rootMargin: -m + "px " + -p + "px " + -x + "px " + -w + "px",
      threshold: I(0, se(1, a)) || 1
    };
    let y = !0;
    function R(C) {
      const S = C[0].intersectionRatio;
      if (S !== a) {
        if (!y)
          return r();
        S ? r(!1, S) : n = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !St(u, e.getBoundingClientRect()) && r(), y = !1;
    }
    try {
      i = new IntersectionObserver(R, {
        ...h,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(R, h);
    }
    i.observe(e);
  }
  return r(!0), s;
}
function at(e, t, i, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = n, u = Me(e), f = o || s ? [...u ? Se(u) : [], ...Se(t)] : [];
  f.forEach((w) => {
    o && w.addEventListener("scroll", i, {
      passive: !0
    }), s && w.addEventListener("resize", i);
  });
  const d = u && c ? On(u, i) : null;
  let g = -1, l = null;
  r && (l = new ResizeObserver((w) => {
    let [v] = w;
    v && v.target === u && l && (l.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var h;
      (h = l) == null || h.observe(t);
    })), i();
  }), u && !a && l.observe(u), l.observe(t));
  let m, p = a ? Q(e) : null;
  a && x();
  function x() {
    const w = Q(e);
    p && !St(p, w) && i(), p = w, m = requestAnimationFrame(x);
  }
  return i(), () => {
    var w;
    f.forEach((v) => {
      o && v.removeEventListener("scroll", i), s && v.removeEventListener("resize", i);
    }), d == null || d(), (w = l) == null || w.disconnect(), l = null, a && cancelAnimationFrame(m);
  };
}
const Cn = sn, Sn = rn, Pn = tn, Dn = ln, En = nn, Mn = cn, Ln = (e, t, i) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: bn,
    ...i
  }, s = {
    ...o.platform,
    _c: n
  };
  return en(e, t, {
    ...o,
    platform: s
  });
};
var Tn = typeof document < "u", kn = function() {
}, de = Tn ? zt : kn;
function pe(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let i, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (i = e.length, i !== t.length) return !1;
      for (n = i; n-- !== 0; )
        if (!pe(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), i = o.length, i !== Object.keys(t).length)
      return !1;
    for (n = i; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = i; n-- !== 0; ) {
      const s = o[n];
      if (!(s === "_owner" && e.$$typeof) && !pe(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Pt(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ut(e, t) {
  const i = Pt(e);
  return Math.round(t * i) / i;
}
function be(e) {
  const t = A.useRef(e);
  return de(() => {
    t.current = e;
  }), t;
}
function $n(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: i = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: s,
      floating: r
    } = {},
    transform: c = !0,
    whileElementsMounted: a,
    open: u
  } = e, [f, d] = A.useState({
    x: 0,
    y: 0,
    strategy: i,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, l] = A.useState(n);
  pe(g, n) || l(n);
  const [m, p] = A.useState(null), [x, w] = A.useState(null), v = A.useCallback((b) => {
    b !== C.current && (C.current = b, p(b));
  }, []), h = A.useCallback((b) => {
    b !== S.current && (S.current = b, w(b));
  }, []), y = s || m, R = r || x, C = A.useRef(null), S = A.useRef(null), P = A.useRef(f), H = a != null, $ = be(a), M = be(o), V = be(u), T = A.useCallback(() => {
    if (!C.current || !S.current)
      return;
    const b = {
      placement: t,
      strategy: i,
      middleware: g
    };
    M.current && (b.platform = M.current), Ln(C.current, S.current, b).then((F) => {
      const W = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: V.current !== !1
      };
      L.current && !pe(P.current, W) && (P.current = W, Jt.flushSync(() => {
        d(W);
      }));
    });
  }, [g, t, i, M, V]);
  de(() => {
    u === !1 && P.current.isPositioned && (P.current.isPositioned = !1, d((b) => ({
      ...b,
      isPositioned: !1
    })));
  }, [u]);
  const L = A.useRef(!1);
  de(() => (L.current = !0, () => {
    L.current = !1;
  }), []), de(() => {
    if (y && (C.current = y), R && (S.current = R), y && R) {
      if ($.current)
        return $.current(y, R, T);
      T();
    }
  }, [y, R, T, $, H]);
  const D = A.useMemo(() => ({
    reference: C,
    floating: S,
    setReference: v,
    setFloating: h
  }), [v, h]), E = A.useMemo(() => ({
    reference: y,
    floating: R
  }), [y, R]), k = A.useMemo(() => {
    const b = {
      position: i,
      left: 0,
      top: 0
    };
    if (!E.floating)
      return b;
    const F = ut(E.floating, f.x), W = ut(E.floating, f.y);
    return c ? {
      ...b,
      transform: "translate(" + F + "px, " + W + "px)",
      ...Pt(E.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: i,
      left: F,
      top: W
    };
  }, [i, c, E.floating, f.x, f.y]);
  return A.useMemo(() => ({
    ...f,
    update: T,
    refs: D,
    elements: E,
    floatingStyles: k
  }), [f, T, D, E, k]);
}
const Fn = (e, t) => ({
  ...Cn(e),
  options: [e, t]
}), Bn = (e, t) => ({
  ...Sn(e),
  options: [e, t]
}), Hn = (e, t) => ({
  ...Mn(e),
  options: [e, t]
}), Wn = (e, t) => ({
  ...Pn(e),
  options: [e, t]
}), Vn = (e, t) => ({
  ...Dn(e),
  options: [e, t]
}), zn = (e, t) => ({
  ...En(e),
  options: [e, t]
});
function In(e = {}) {
  const {
    nodeId: t
  } = e, i = Zt({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || i, o = n.elements, [s, r] = A.useState(null), [c, a] = A.useState(null), f = (o == null ? void 0 : o.domReference) || s, d = A.useRef(null), g = Qt();
  Ce(() => {
    f && (d.current = f);
  }, [f]);
  const l = $n({
    ...e,
    elements: {
      ...o,
      ...c && {
        reference: c
      }
    }
  }), m = A.useCallback((h) => {
    const y = z(h) ? {
      getBoundingClientRect: () => h.getBoundingClientRect(),
      getClientRects: () => h.getClientRects(),
      contextElement: h
    } : h;
    a(y), l.refs.setReference(y);
  }, [l.refs]), p = A.useCallback((h) => {
    (z(h) || h === null) && (d.current = h, r(h)), (z(l.refs.reference.current) || l.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    h !== null && !z(h)) && l.refs.setReference(h);
  }, [l.refs]), x = A.useMemo(() => ({
    ...l.refs,
    setReference: p,
    setPositionReference: m,
    domReference: d
  }), [l.refs, p, m]), w = A.useMemo(() => ({
    ...l.elements,
    domReference: f
  }), [l.elements, f]), v = A.useMemo(() => ({
    ...l,
    ...n,
    refs: x,
    elements: w,
    nodeId: t
  }), [l, x, w, t, n]);
  return Ce(() => {
    n.dataRef.current.floatingContext = v;
    const h = g == null ? void 0 : g.nodesRef.current.find((y) => y.id === t);
    h && (h.context = v);
  }), A.useMemo(() => ({
    ...l,
    context: v,
    refs: x,
    elements: w
  }), [l, x, w, v]);
}
const _n = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    var F, W;
    const {
      x: i,
      y: n,
      placement: o,
      rects: s,
      platform: r,
      elements: c,
      middlewareData: a
    } = t, {
      element: u,
      padding: f = 0,
      offsetParent: d = "real"
    } = U(e, t) || {};
    if (u == null)
      return {};
    const g = gt(f), l = {
      x: i,
      y: n
    }, m = ht(o), p = pt(m), x = await r.getDimensions(u), w = m === "y", v = w ? "top" : "left", h = w ? "bottom" : "right", y = w ? "clientHeight" : "clientWidth", R = s.reference[p] + s.reference[m] - l[m] - s.floating[p], C = l[m] - s.reference[m], S = d === "real" ? await ((F = r.getOffsetParent) == null ? void 0 : F.call(r, u)) : c.floating;
    let P = c.floating[y] || s.floating[p];
    (!P || !await ((W = r.isElement) == null ? void 0 : W.call(r, S))) && (P = c.floating[y] || s.floating[p]);
    const H = R / 2 - C / 2, $ = P / 2 - x[p] / 2 - 1, M = Math.min(g[v], $), V = Math.min(g[h], $), T = M, L = P - x[p] - V, D = P / 2 - x[p] / 2 + H, E = Oe(T, D, L), k = !a.arrow && ie(o) != null && D !== E && s.reference[p] / 2 - (D < T ? M : V) - x[p] / 2 < 0, b = k ? D < T ? D - T : D - L : 0;
    return {
      [m]: l[m] + b,
      data: {
        [m]: E,
        centerOffset: D - E - b,
        ...k && {
          alignmentOffset: b
        }
      },
      reset: k
    };
  }
}), jn = (e, t) => ({
  ..._n(e),
  options: [e, t]
});
function Dt(e, t, i) {
  const n = e === "inline-start" || e === "inline-end";
  return {
    top: "top",
    right: n ? i ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: n ? i ? "inline-end" : "inline-start" : "left"
  }[t];
}
function dt(e, t, i) {
  const {
    rects: n,
    placement: o
  } = e;
  return {
    side: Dt(t, q(o), i),
    align: ie(o) || "center",
    anchor: {
      width: n.reference.width,
      height: n.reference.height
    },
    positioner: {
      width: n.floating.width,
      height: n.floating.height
    }
  };
}
function ei(e) {
  var Je, Qe;
  const {
    // Public parameters
    anchor: t,
    positionMethod: i = "absolute",
    side: n = "bottom",
    sideOffset: o = 0,
    align: s = "center",
    alignOffset: r = 0,
    collisionBoundary: c,
    collisionPadding: a = 5,
    sticky: u = !1,
    arrowPadding: f = 5,
    trackAnchor: d = !0,
    // Private parameters
    keepMounted: g = !1,
    floatingRootContext: l,
    mounted: m,
    collisionAvoidance: p,
    shiftCrossAxis: x = !1,
    nodeId: w,
    adaptiveOrigin: v
  } = e, h = p.side || "flip", y = p.align || "flip", R = p.fallbackAxisSide || "end", C = typeof t == "function" ? t : void 0, S = Ut(C), P = C ? S : t, H = Re(t), M = Xt() === "rtl", V = {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": M ? "left" : "right",
    "inline-start": M ? "right" : "left"
  }[n], T = s === "center" ? V : `${V}-${s}`, L = {
    boundary: c === "clipping-ancestors" ? "clippingAncestors" : c,
    padding: a
  }, D = A.useRef(null), E = Re(o), k = Re(r), W = [Fn((O) => {
    const B = dt(O, n, M), _ = typeof E.current == "function" ? E.current(B) : E.current, j = typeof k.current == "function" ? k.current(B) : k.current;
    return {
      mainAxis: _,
      crossAxis: j,
      alignmentAxis: j
    };
  }, [typeof o != "function" ? o : 0, typeof r != "function" ? r : 0, M, n])], Te = y === "none" && h !== "shift", ke = !Te && (u || x || h === "shift"), $e = h === "none" ? null : Wn({
    ...L,
    mainAxis: !x && h === "flip",
    crossAxis: y === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: R
  }), Fe = Te ? null : Bn((O) => {
    const B = qt(O.elements.floating).documentElement;
    return {
      ...L,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: x ? {
        x: 0,
        y: 0,
        width: B.clientWidth,
        height: B.clientHeight
      } : void 0,
      mainAxis: y !== "none",
      crossAxis: ke,
      limiter: u || x ? void 0 : Hn(() => {
        if (!D.current)
          return {};
        const {
          height: _
        } = D.current.getBoundingClientRect();
        return {
          offset: _ / 2 + (typeof a == "number" ? a : 0)
        };
      })
    };
  }, [L, u, x, a, y]);
  h === "shift" || y === "shift" || s === "center" ? W.push(Fe, $e) : W.push($e, Fe), W.push(Vn({
    ...L,
    apply({
      elements: {
        floating: O
      },
      rects: {
        reference: B
      },
      availableWidth: _,
      availableHeight: j
    }) {
      Object.entries({
        "--available-width": `${_}px`,
        "--available-height": `${j}px`,
        "--anchor-width": `${B.width}px`,
        "--anchor-height": `${B.height}px`
      }).forEach(([ae, ye]) => {
        O.style.setProperty(ae, ye);
      });
    }
  }), jn(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: D.current || document.createElement("div"),
    padding: f,
    offsetParent: "floating"
  }), [f]), zn(), {
    name: "transformOrigin",
    fn(O) {
      var tt, nt, it;
      const {
        elements: B,
        middlewareData: _,
        placement: j,
        rects: ae,
        y: ye
      } = O, Ze = q(j), Mt = N(Ze), te = D.current, Lt = ((tt = _.arrow) == null ? void 0 : tt.x) || 0, Tt = ((nt = _.arrow) == null ? void 0 : nt.y) || 0, kt = (te == null ? void 0 : te.clientWidth) || 0, $t = (te == null ? void 0 : te.clientHeight) || 0, ve = Lt + kt / 2, et = Tt + $t / 2, Ft = Math.abs(((it = _.shift) == null ? void 0 : it.y) || 0), Bt = ae.reference.height / 2, Ht = Ft > (typeof o == "function" ? o(dt(O, n, M)) : o), Wt = {
        top: `${ve}px calc(100% + ${o}px)`,
        bottom: `${ve}px ${-o}px`,
        left: `calc(100% + ${o}px) ${et}px`,
        right: `${-o}px ${et}px`
      }[Ze], Vt = `${ve}px ${ae.reference.y + Bt - ye}px`;
      return B.floating.style.setProperty("--transform-origin", ke && Mt === "y" && Ht ? Vt : Wt), {};
    }
  }, v);
  let Be = l;
  !m && l && (Be = {
    ...l,
    elements: {
      reference: null,
      floating: null,
      domReference: null
    }
  });
  const we = A.useMemo(() => ({
    elementResize: d && typeof ResizeObserver < "u",
    layoutShift: d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: Z,
    elements: oe,
    x: He,
    y: We,
    middlewareData: ee,
    update: le,
    placement: Ve,
    context: ze,
    isPositioned: Ie,
    floatingStyles: _e
  } = In({
    rootContext: Be,
    placement: T,
    middleware: W,
    strategy: i,
    whileElementsMounted: g ? void 0 : (...O) => at(...O, we),
    nodeId: w
  }), {
    sideX: je,
    sideY: Ne
  } = ee.adaptiveOrigin || {}, Ye = A.useMemo(() => v ? {
    position: i,
    [je]: `${He}px`,
    [Ne]: `${We}px`
  } : _e, [v, je, Ne, i, He, We, _e]), fe = A.useRef(null);
  Ce(() => {
    if (!m)
      return;
    const O = H.current, B = typeof O == "function" ? O() : O, j = (mt(B) ? B.current : B) || null || null;
    j !== fe.current && (Z.setPositionReference(j), fe.current = j);
  }, [m, Z, P, H]), A.useEffect(() => {
    if (!m)
      return;
    const O = H.current;
    typeof O != "function" && mt(O) && O.current !== fe.current && (Z.setPositionReference(O.current), fe.current = O.current);
  }, [m, Z, P, H]), A.useEffect(() => {
    if (g && m && oe.domReference && oe.floating)
      return at(oe.domReference, oe.floating, le, we);
  }, [g, m, oe, le, we]);
  const Et = q(Ve), qe = Dt(n, Et, M), Ue = ie(Ve) || "center", Xe = !!((Je = ee.hide) != null && Je.referenceHidden), Ke = A.useMemo(() => {
    var O, B;
    return {
      position: "absolute",
      top: (O = ee.arrow) == null ? void 0 : O.y,
      left: (B = ee.arrow) == null ? void 0 : B.x
    };
  }, [ee.arrow]), Ge = ((Qe = ee.arrow) == null ? void 0 : Qe.centerOffset) !== 0;
  return A.useMemo(() => ({
    positionerStyles: Ye,
    arrowStyles: Ke,
    arrowRef: D,
    arrowUncentered: Ge,
    side: qe,
    align: Ue,
    anchorHidden: Xe,
    refs: Z,
    context: ze,
    isPositioned: Ie,
    update: le
  }), [Ye, Ke, D, Ge, qe, Ue, Xe, Z, ze, Ie, le]);
}
function mt(e) {
  return e != null && "current" in e;
}
export {
  ei as u
};
